import { createEffect } from '@databases/selections';
import type {
  ResolvedSelection,
  SelectionsApiContract,
} from '@databases/selections-api-types';
import { type DatabaseLayoutType } from '@databases/types/database/view';

const computeResolvedSelection = (
  resolvedSelection: ResolvedSelection,
  currentViewType: DatabaseLayoutType
): string[] => {
  const entryPrefix = currentViewType === 'table' ? 'entry' : 'card';
  switch (resolvedSelection.mode) {
    case 'row':
      return resolvedSelection.entries.map((entry) => `${entryPrefix}:${entry.entryId}`);
    case 'column':
      return resolvedSelection.fields.map((field) => `field:${field.fieldId}`);
    case 'cell':
      return resolvedSelection.values.map(
        (value) => `cell:${value.entryId}:${value.fieldId}`
      );
    case 'idle':
      return [];
  }
};

export const createPublishRovoSelectionEffect = createEffect(
  ({
    selectionsApi,
    publishSelectionToRovo,
    currentViewType,
  }: {
    selectionsApi: SelectionsApiContract;
    publishSelectionToRovo: (selection: string[]) => void;
    currentViewType: DatabaseLayoutType;
  }) => {
    return {
      deltaTypes: ['selectionReplaced', 'selectionModified', 'focusChanged'],

      dispose() {
        publishSelectionToRovo([]);
      },

      onDelta(_delta, _state) {
        const resolvedSelection = selectionsApi.getResolvedSelection();
        const activeSelection = computeResolvedSelection(
          resolvedSelection,
          currentViewType
        );
        publishSelectionToRovo(activeSelection);
      },
    };
  }
);
